﻿module Sm.UI.Components.MainView

open Fable.React
open Fable.React.Props
open MobF.React

open Sm.UI
open Sm.UI.Main

type Props = {
    Main: Main.Type
}

[<ObserverComponent>]
let Progress (props: {| Main: Main.Type |}) =
    let info = props.Main.Computed.Progress

    match info with
    | None -> nothing
    | Some { Text = text; Subtext = subtext; Value = value } ->
        dialog [Class "is-dark is-progress"; Open true] [
            label [] [str text]
            p [] [str subtext]

            let style = Style [
                Custom ("--value", sprintf "%f%%" value)
            ]
            div [Class "progress-bar"; style] []
        ]

[<ObserverComponent>]
let ReloadAlert (props: {| Main: Main.Type |}) =
    let main = props.Main

    match main.Computed.ReloadMessage with
    | None -> nothing
    | Some message ->
        fragment [] [
            div [Id "modal-mask"; Class "dark"] []

            dialog [Class "is-dark is-reload"; Open true] [
                label [] [str "Update"]
                p [] [str message]

                let onClick _ = main.Post(Reload)
                button [OnClick onClick] [str "Reload"]
            ]
        ]

[<ObserverComponent>]
let MainView (props: Props) =
    let main = props.Main
    let timer = main.State.Timer
    let pad = main.State.Pad

    let classList = renderClassList [
        Append "main-view"
    ]

    Standard.main [Class classList] [
        NavBar.NavBar {| Main = main |}

        PadView.PadView {|
            Pad = pad
            Timer = timer
            Autotimer = main.State.Autotimer
        |}

        Progress {| Main = main |}
        ReloadAlert {| Main = main |}
    ]
